export default __webpack_public_path__ + "static/media/list-your-practice.91ef8ebf.png";